import dayjs from 'dayjs/esm';
import duration from 'dayjs/esm/plugin/duration';
import { FacettenOptionInfo } from '../services/facetten/facetten-option-info';

dayjs.extend(duration);

/**
 * Repräsentation der Dauer aus dem Backend
 */
export interface Dauer {
  id: number;
  bezeichnung: string;
}

export type DauerBezeichnungWithTimeReference = {
  label: string;
  ariaLabel?: string;
  id: number;
  duration: duration.Duration | number;
};

const dauerBezeichnungWithTimeReference: DauerBezeichnungWithTimeReference[] = [
  {
    id: 0,
    label: 'Auf Anfrage',
    duration: Infinity
  },
  {
    id: 1,
    label: '1 - 3 Tage',
    ariaLabel: '1 bis 3 Tage',
    duration: dayjs.duration({
      seconds: 1,
      days: 3
    })
  },
  {
    id: 2,
    label: '4 - 7 Tage',
    ariaLabel: '1 bis 3 Tage',
    duration: dayjs.duration({
      seconds: 1,
      days: 7
    })
  },
  {
    id: 3,
    label: '1 - 4 Wochen',
    ariaLabel: '1 bis 3 Tage',
    duration: dayjs.duration({
      seconds: 1,
      weeks: 4
    })
  },
  {
    id: 4,
    label: '1 - 3 Monate',
    ariaLabel: '1 bis 3 Tage',
    duration: dayjs.duration({
      seconds: 1,
      months: 3
    })
  },
  {
    id: 5,
    label: '3 - 6 Monate',
    ariaLabel: '3 bis 6 Monate',
    duration: dayjs.duration({
      seconds: 1,
      months: 6
    })
  },
  {
    id: 6,
    label: '6 - 12 Monate',
    ariaLabel: '6 bis 12 Monate',
    duration: dayjs.duration({
      seconds: 1,
      years: 1
    })
  },
  {
    id: 7,
    label: '1 - 2 Jahre',
    ariaLabel: '1 bis 2 Jahre',
    duration: dayjs.duration({
      seconds: 1,
      years: 2
    })
  },
  {
    id: 8,
    label: '2 - 3 Jahre',
    ariaLabel: '2 bis 3 Jahre',
    duration: dayjs.duration({
      seconds: 1,
      years: 3
    })
  },
  {
    id: 9,
    label: '3 Jahre +',
    duration: Infinity
  }
];

/**
 * Ordnet einem Label den Integrationstyp über den key zu
 * Mappt Systematik auf Anzeigetexte
 */
export const orderedDauerBezeichnung: FacettenOptionInfo[] = dauerBezeichnungWithTimeReference.map(
  (item) => ({ id: item.id.toString(), bezeichnung: item.label })
);

export const getDauerKurzbezeichnungWithTimeRefence = (
  id: number
): DauerBezeichnungWithTimeReference => dauerBezeichnungWithTimeReference[id];
